import { render } from "./EntityPanel.vue?vue&type=template&id=bcdfc210"
import script from "./EntityPanel.vue?vue&type=script&lang=js"
export * from "./EntityPanel.vue?vue&type=script&lang=js"

import "./EntityPanel.vue?vue&type=style&index=0&id=bcdfc210&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__